import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core"
import { ToastsManager } from 'ng2-toastr';
import { Observable } from "rxjs";
import { Router } from '@angular/router';

@Injectable(

)
export class InterceptorService implements HttpInterceptor {

  constructor(
    private toastr: ToastsManager,
    private router: Router
  ) { }
  // intercept(
  //   req: HttpRequest<any>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<any>> {


  //   return next.handle(req).pipe(
  //     tap(evt => {

  //       if (evt instanceof HttpResponse) {
  //         if (evt.body)
  //           if (evt.body.result != undefined)
  //             if (!evt.body.result) {

  //               //this.toastr.error(evt.body.message);

  //             }
  //       }
  //     }),
  //     catchError((err: any) => {

  //       if (err instanceof HttpErrorResponse) {

  //         try {
  //           if (err.status === 401) {

  //             this.redirectWeb();

  //           }
  //           // else
  //           //   this.toastr.error(err.message);

  //         } catch (e) {
  //           console.log('intercept', err);
  //         }

  //       }
  //       return of(err);
  //     }));

  // }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.info('req.headers =', req.headers, ';');
    return next.handle(req)
      .map((event: HttpEvent<any>) => {
        // if (event instanceof HttpResponse && ~~(event.status / 100) > 3) {
        //   console.info('HttpResponse::event =', event, ';');
        // } else console.info('event =', event, ';');
        return event;
      })
      .catch((err: any, caught) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.redirectWeb();
          }
          return Observable.throw(err);
        }
      });
  }

  private redirectWeb() {
    this.toastr.info('Su sesión ha expirado, sera redireccionado.');
    localStorage.setItem('key', '');
    localStorage.setItem('Bearer', '');
    const redirect = '/authentication/login';
    this.router.navigate([redirect]);
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptor/interceptor.service.ts